<template>
  <div class="content-single-3">
    <m-single-content-wrapper :contentLink="contentLink"
                              content-type="page">
      <template v-slot="{content}">
        <m-a :href="findLinkOnContent(content.abstraction)">
          <img class="content-single-3-image" :src="content.thumbnail" :alt="content.title">
        </m-a>
      </template>
    </m-single-content-wrapper>
  </div>
</template>

<script>
import {ContentSingleProps} from "./ContentSingleProps";
import mSingleContentWrapper from "../../Wrappers/SingleContentWrapper";
import mA from "../../Tags/A";

export default {
  name: "ContentSingle3",
  components: {mA, mSingleContentWrapper},
  props: {
    ...ContentSingleProps
  }
}
</script>

<style scoped>
.content-single-3-image {
  width: 100%;
}
</style>